// import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
// import PersonOutlineOutlinedIcon from "@mui/icons-material/PersonOutlineOutlined";
// import ShuffleIcon from "@mui/icons-material/Shuffle";
// import CurrencyRupeeOutlinedIcon from "@mui/icons-material/CurrencyRupeeOutlined";
// import AssignmentIndOutlinedIcon from "@mui/icons-material/AssignmentIndOutlined";
// import AccountBalanceOutlinedIcon from "@mui/icons-material/AccountBalanceOutlined";
// import MailOutlineIcon from "@mui/icons-material/MailOutline";
// import AltRouteIcon from "@mui/icons-material/AltRoute";
// import RouterIcon from "@mui/icons-material/Router";
// import AddToHomeScreenIcon from "@mui/icons-material/AddToHomeScreen";
// import TrendingUpIcon from "@mui/icons-material/TrendingUp";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faLink } from "@fortawesome/free-solid-svg-icons";
// import SupportAgentIcon from "@mui/icons-material/SupportAgent";
// import LibraryBooksIcon from "@mui/icons-material/LibraryBooks";
// import MenuBookOutlinedIcon from "@mui/icons-material/MenuBookOutlined";
// import MobileFriendlyOutlinedIcon from "@mui/icons-material/MobileFriendlyOutlined";
// import TouchAppOutlinedIcon from "@mui/icons-material/TouchAppOutlined";
// import SwapHorizIcon from "@mui/icons-material/SwapHoriz";
// import SwipeRightOutlinedIcon from "@mui/icons-material/SwipeRightOutlined";
// import BoltIcon from "@mui/icons-material/Bolt";
// import BugReportIcon from "@mui/icons-material/BugReport";
// import NotificationsIcon from "@mui/icons-material/Notifications";
import SettingsIcon from "@mui/icons-material/Settings";
import CallMadeIcon from "@mui/icons-material/CallMade";
import FormatBoldIcon from "@mui/icons-material/FormatBold";
import DashboardIcon from "./assets/sidenav/dashboard.svg";
import cmsIcon from "./assets/sidenav/cms.svg";
import DashboardIconWhite from "./assets/sidenav/white/dashboard.svg";
import AccountIcon from "./assets/sidenav/accounts.svg";
import InstantIcon from "./assets/sidenav/instant.svg";
import BankIcon from "./assets/sidenav/bank.svg";
import ComplaintsIcon from "./assets/sidenav/complaints.svg";
import MessagesIcon from "./assets/sidenav/messages.svg";
import NotificationIcon from "./assets/sidenav/notifications.svg";
import OperatorsIcon from "./assets/sidenav/operators.svg";
import PlansIcon from "./assets/sidenav/plans.svg";
import PrabhuIcon from "./assets/sidenav/prabhu_transfer.svg";
import RoutesIcon from "./assets/sidenav/routes.svg";
import TransactionIcon from "./assets/sidenav/transactions.svg";
import UserIcon from "./assets/sidenav/user.svg";
import user1 from "./assets/sidenav/user1.svg";
import FlightIcon from "./assets/sidenav/flight_booking.svg";
import AepsIcon from "./assets/sidenav/aeps.svg";
import BbpsIcon from "./assets/sidenav/bbps.svg";
import CreditRequestIcon from "./assets/sidenav/credit_request.svg";
import SendMoneyI from "./assets/sidenav/sendmoney.svg";
import ExpressIcon from "./assets/sidenav/express_transfer.svg";
import MoneyTransferIcon from "./assets/sidenav/money_transfer.svg";
import NepalIcon from "./assets/sidenav/nepal_transfer.svg";
import RechargeIcon from "./assets/sidenav/recharge_bill.svg";
import ReportsIcon from "./assets/sidenav/reports.svg";
import SuperIcon from "./assets/sidenav/super_transfer.svg";
import UpiIcon from "./assets/sidenav/upi_transfer.svg";
import employeesIcon from "./assets/sidenav/employee_icon.svg";
import AccountIconWhite from "./assets/sidenav/white/accounts.svg";
import BankIconWhite from "./assets/sidenav/white/bank.svg";
import ComplaintsIconWhite from "./assets/sidenav/white/complaints.svg";
import MessagesIconWhite from "./assets/sidenav/white/messages.svg";
import NotificationIconWhite from "./assets/sidenav/white/notifications.svg";
import OperatorsIconWhite from "./assets/sidenav/white/operators.svg";
import PlansIconWhite from "./assets/sidenav/white/plans.svg";
import PrabhuIconWhite from "./assets/sidenav/white/prabhu_transfer.svg";
import RoutesIconWhite from "./assets/sidenav/white/routes.svg";
import TransactionIconWhite from "./assets/sidenav/white/transactions.svg";
import UserIconWhite from "./assets/sidenav/white/user.svg";
import InstantIconWhite from "./assets/sidenav/white/instant.svg";
import cmsIconWhite from "./assets/sidenav/white/cms.svg";
import employeesIconWhite from "./assets/sidenav/white/employee_icon_white.svg";
import trainIconWhite from "./assets/sidenav/white/train.svg";
import dashboards from "./assets/sidenav/dashboards.svg";
import transfer1 from "./assets/sidenav/transfer1.svg";
import creditrq1 from "./assets/sidenav/creditrq1.svg";
import account1 from "./assets/sidenav/account1.svg";
import transaction1 from "./assets/sidenav/white/transaction1.svg";
import mysale from "./assets/sidenav/white/mysale.svg";
import bank1 from "./assets/sidenav/bank1.svg";
import message1 from "./assets/sidenav/message1.svg";
import notification1 from "./assets/sidenav/notification1.svg";
import route1 from "./assets/sidenav/route1.svg";
import employee1 from "./assets/sidenav/employee1.svg";
import operator1 from "./assets/sidenav/operator1.svg";
import plan1 from "./assets/sidenav/plan1.svg";
import virtualaccount1 from "./assets/sidenav/virtualaccount1.svg";
import complaint1 from "./assets/sidenav/complaint1.svg";
import risk1 from "./assets/sidenav/risk1.svg";
import mypurchase from "./assets/sidenav/mypurchase.svg";
import train from "./assets/sidenav/train.svg";
import Upi from "./assets/sidenav/Upi.svg";
import creditmoney from "./assets/sidenav/creditmoney.svg";
import Reports1 from "./assets/sidenav/Reports1.svg";
import Recharge from "./assets/sidenav/Recharge.svg";
import Travel from "./assets/sidenav/Travel.svg";
import AEPS1 from "./assets/sidenav/AEPS1.svg";
import complaint from "./assets/sidenav/complaint.svg";
import Cms2 from "./assets/sidenav/Cms2.svg";
import graph from "./assets/sidenav/graph.svg";
import Qr from "./assets/Qr.svg";
import Book from "./assets/sidenav/book.svg";
import bharatbig from "./assets/sidenav/bharatbig.svg";
import home from "./assets/home.svg";
import loginHistory from "./assets/loginhistory.svg";
import QrCode2Icon from "@mui/icons-material/QrCode2";
import AccountBalanceWalletIcon from "@mui/icons-material/AccountBalanceWallet";
import AccountBalanceIcon from "@mui/icons-material/AccountBalance";
import bankTransfer from "./assets/banktransfer.svg";
import sendicon from "./assets/send.svg";
import walletIcon from "./assets/wallet.svg";
import ledgerIcon from "./assets/ledger.svg";
import myprofile from "./assets/myprofile.svg";
import invoicesvg from "./assets/sidenav/envoicesvg.svg";
import {
  account_ledgre,
  aepsIcon,
  bbIcon,
  cardIcon,
  creditReq,
  dashboard,
  dthIcon,
  elecIcon,
  etIcon,
  gasIcon,
  khataBook,
  mtIcon,
  myComplaints,
  myPurchase,
  ntIcon,
  stIcon,
  transactions,
  utIcon,
  Electricity,
  FASTag,
  Cylinder,
  Postpaid,
  Prepaid,
  Gas,
  BBPS,
  licIcon,
  waterIcon,
  landIcon,
  flightBooking,
  hotelBooking,
  busBooking,
  CMSIcon,
  irctcTravelImage,
  maleAvatar,
  femaleAvatar,
} from "./iconsImports";
import SendMoneyModal from "./modals/SendMoneyModal";

export const nav = [
  {
    title: "Dashboard",
    icon: dashboards,
    icon2: DashboardIconWhite,
    to: "/dashboard",
  },
  {
    title: "Recharge",
    icon: RechargeIcon,
    icon2: RechargeIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "Money Transfer",
    icon: MoneyTransferIcon,
    icon2: MoneyTransferIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "Express Transfer",
    icon: ExpressIcon,
    icon2: ExpressIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "UPI Transfer",
    icon: UpiIcon,
    icon2: UpiIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "AEPS",
    icon: AepsIcon,
    icon2: AepsIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "Transaction",
    icon: InstantIcon,
    icon2: InstantIconWhite,
    to: "/dashboard/transaction",
  },
  {
    title: "Fund Request",
    icon: CreditRequestIcon,
    icon2: CreditRequestIcon,
    to: "/dashboard/transaction",
  },
  {
    title: "Contact Us",
    icon: InstantIcon,
    icon2: InstantIconWhite,
    to: "/dashboard/transaction",
  },
];
export const Admin_nav = [
  {
    title: "Dashboard",
    icon: dashboards,
    icon2: DashboardIconWhite,
    to: "/admin/dashboard",
  },
  {
    title: "Users",
    icon: user1,
    icon2: UserIconWhite,
    to: "/admin/users",
  },

  {
    title: "Transactions",
    icon: transaction1,
    icon2: TransactionIconWhite,
    to: "/admin/transactions",
  },
  // {
  //   title: "Prabhu Transfer",
  //   icon: transfer1,
  //   icon2: PrabhuIconWhite,
  //   to: "/admin/prabhu",
  // },
  {
    title: "Fund Request",
    icon: creditrq1,
    icon2: CreditRequestIcon,
    to: "/admin/cred-req",
  },
  // {
  //   title: "Accounts",
  //   icon: account1 ,
  //   icon2: AccountIconWhite,
  //   to: "/admin/accounts",
  // },
  // {
  //   title: "Banks",
  //   icon: bank1,
  //   icon2: BankIconWhite,
  //   to: "/admin/banks",
  // },
  {
    title: "Banking",
    icon: bank1,
    icon2: BankIconWhite,
    to: "/admin/banking",
  },
  {
    title: "Collections",
    icon: bank1,
    icon2: BankIconWhite,
    to: "/admin/collection",
  },
  {
    title: "Wallet Balance",
    icon: creditrq1,
    icon2: CreditRequestIcon,
    to: "/admin/walletbalancezy",
  },

  {
    title: "Messages",
    icon: message1,
    icon2: MessagesIconWhite,
    to: "/admin/messages",
  },
  // {
  //   title: "Notifications",
  //   icon: notification1,
  //   icon2: NotificationIconWhite,
  //   to: "/admin/notification",
  // },
  {
    title: "Pg Orders",
    icon: operator1,
    icon2: OperatorsIconWhite,
    to: "/admin/pgorder",
  },
  {
    title: "Services",
    icon: operator1,
    icon2: OperatorsIconWhite,
    to: "/admin/serviceszy",
  },

  // {
  //   title: "Routes",
  //   icon: route1,
  //   icon2: RoutesIconWhite,
  //   to: "/admin/routes",
  // },
  // {
  //   title: "Plans",
  //   icon: plan1,
  //   icon2: PlansIconWhite,
  //   to: "/admin/plans",
  // },
  {
    title: "Complaint",
    icon: complaint1,
    icon2: ComplaintsIconWhite,
    to: "/admin/complaints",
  },
  {
    title: "Leads",
    icon: complaint1,
    icon2: ComplaintsIconWhite,
    to: "/admin/leads",
  },
  //  {
  //   title: "Leads",
  //   icon: complaint1,
  //   icon2: ComplaintsIconWhite,
  //   to: "/admin/leads",
  // },
  {
    title: "Sett. Accounts",
    icon: risk1,
    icon2: AccountIconWhite,
    to: "/admin/riskzy",
  },

  //   {
  //   title: "Virtual Accounts",
  //   icon: virtualaccount1,
  //   icon2: AccountIconWhite,
  //   to: "/admin/virtual-accounts",
  // },
  {
    title: "Scheme",
    icon: loginHistory,
    icon2: TransactionIconWhite,
    to: "/admin/schemezy",
  },
  {
    title: "Pan Link",
    icon: myprofile,
    icon2: CreditRequestIcon,
    to: "/admin/panlink",
  },
  {
    title: "Api Settings",
    icon: graph,
    icon2: ReportsIcon,
    to: "/admin/api-settings",
    allowedUsers: [1, 5861, 5855],
    submenus: [
      {
        title: "User Keys",
        icon: mypurchase,
        icon2: TransactionIconWhite,
        to: "/admin/user-keyszy",
      },
      {
        title: "User Services",
        icon: mysale,
        icon2: TransactionIconWhite,
        to: "/admin/user-serviceszy",
      },
      {
        title: "Charges",
        icon: mysale,
        icon2: TransactionIconWhite,
        to: "/admin/chargeszy",
      },
    ],
  },
  {
    title: "Balances",
    icon: myprofile,
    icon2: CreditRequestIcon,
    to: "/admin/balances",
  },
  {
    title: "Closing Balance",
    icon: myprofile,
    icon2: CreditRequestIcon,
    to: "/admin/closing-balancezy",
  },
  // {
  //   title: "Account Ledger",
  //   icon: ledgerIcon,
  //   icon2: ledgerIcon,
  //   to: "/admin/account-ledger",
  // },

  {
    title: "Login History",
    icon: loginHistory,
    icon2: TransactionIconWhite,
    to: "/admin/loginHistory",
  },
  {
    title: "My-Profile",
    icon: myprofile,
    icon2: myprofile,
    to: "/admin/myprofile",
  },

  {
    title: "App Version",
    icon: myprofile,
    icon2: employeesIconWhite,
    to: "/admin/app_version",
  },
  // {
  //   title: "Invoices",
  //   icon: myprofile,
  //   icon2: employeesIconWhite,
  //   to: "/admin/invoice",
  // },
];
export const Asm_nav = [
  {
    title: "Dashboard",
    icon: dashboards,
    icon2: DashboardIconWhite,
    to: "/asm/dashboard",
  },
  {
    title: "Users",
    icon: user1,
    icon2: UserIconWhite,
    to: "/asm/users",
  },
  {
    title: "Transactions",
    icon: transaction1,
    icon2: TransactionIconWhite,
    to: "/asm/transactions",
  },
  // {
  //   title: "Fund Request",
  //   icon: creditrq1,
  //   icon2: CreditRequestIcon,
  //   to: "/asm/cred-req",
  // },
  // {
  //   title: "Bank List",
  //   icon: creditrq1,
  //   icon2: CreditRequestIcon,
  //   to: "/asm/bank-list",
  // },

  {
    title: "Login History",
    icon: loginHistory,
    icon2: TransactionIconWhite,
    to: "/asm/loginHistory",
  },
  {
    title: "My-profile",
    icon: myprofile,
    icon2: myprofile,
    to: "/asm/myprofile",
  },
];
export const Zsm_nav = [
  {
    title: "Dashboard",
    icon: dashboards,
    icon2: DashboardIconWhite,
    to: "/zsm/dashboard",
  },
  {
    title: "Users",
    icon: user1,
    icon2: UserIconWhite,
    to: "/zsm/users",
  },
  {
    title: "Transactions",
    icon: transaction1,
    icon2: TransactionIconWhite,
    to: "/zsm/transactions",
  },
  // {
  //   title: "Fund  Request",
  //   icon: creditrq1,
  //   icon2: CreditRequestIcon,
  //   to: "/zsm/cred-req",
  // },
  // {
  //   title: "Bank List",
  //   icon: creditrq1,
  //   icon2: CreditRequestIcon,
  //   to: "/asm/bank-list",
  // },
  {
    title: "Login History",
    icon: loginHistory,
    icon2: TransactionIconWhite,
    to: "/asm/loginHistory",
  },
  {
    title: "My-profile",
    icon: myprofile,
    icon2: myprofile,
    to: "/zsm/myprofile",
  },
];
export const Api_nav = [
  // {
  //   title: "Dashboard",
  //   icon: dashboards,
  //   icon2: DashboardIconWhite,
  //   to: "/api-user/dashboard",
  // },
  {
    title: "Transactions",
    icon: transaction1,
    icon2: TransactionIconWhite,
    to: "/api-user/transactions",
  },
  {
    title: "Account Ledger",
    icon: transaction1,
    icon2: TransactionIconWhite,
    to: "/api-user/accountledger",
  },
  // {
  //   title: "Account ledger",
  //   icon: ledgerIcon,
  //   icon2: ledgerIcon,
  //   to: "/api-user/account-ledger",
  // },
  {
    title: "Fund Request",
    icon: creditrq1,
    icon2: CreditRequestIcon,
    to: "/api-user/cred-req",
  },
  {
    title: "Pan Link",
    icon: myprofile,
    icon2: CreditRequestIcon,
    to: "/api-user/panlink",
  },
  // {
  //   title: "Invoices",
  //   icon: myprofile,
  //   icon2: employeesIconWhite,
  //   to: "/api-user/invoice",
  // },
  // {
  //   title: "Documents",
  //   icon: myprofile,
  //   icon2: employeesIconWhite,
  //   to: "/api-user/documents",
  // },
  {
    title: "Login History",
    icon: loginHistory,
    icon2: TransactionIconWhite,
    to: "/api-user/loginHistory",
  },
  {
    title: "My-profile",
    icon: myprofile,
    icon2: myprofile,
    to: "/api-user/myprofile",
  },
];

export const Ad_nav = [
  {
    title: "Home",
    icon: home,
    icon2: home,
    to: "/ad/dashboard",
  },
  {
    title: "Users",
    icon: user1,
    icon2: UserIconWhite,
    to: "/ad/users",
  },
  {
    title: "Fund Request",
    icon: creditrq1,
    icon2: CreditRequestIcon,
    to: "/ad/cred-req",
  },
  {
    title: "Transactions",
    icon: transaction1,
    icon2: TransactionIconWhite,
    to: "/ad/transactions",
  },

  // {
  //   title: "Bank List",
  //   icon: creditrq1,
  //   icon2: CreditRequestIcon,
  //   to: "/ad/bank-list",
  // },
  {
    title: "Reports",
    icon: graph,
    icon2: ReportsIcon,
    to: "/ad/reports",
    submenus: [
      {
        title: "Value In",
        icon: mypurchase,
        icon2: TransactionIconWhite,
        to: "/ad/purchase",
      },
      {
        title: "Value Out",
        icon: mysale,
        icon2: TransactionIconWhite,
        to: "/ad/sale",
      },
    ],
  },
  {
    title: "My Earning",
    icon: graph,
    icon2: ReportsIcon,
    to: "/ad/my-earning",
  },

  {
    title: "Account Ledger",
    icon: ledgerIcon,
    icon2: ledgerIcon,
    to: "/ad/account-ledger",
  },
  {
    title: "Login History",
    icon: loginHistory,
    icon2: TransactionIconWhite,
    to: "/ad/loginHistory",
  },
  {
    title: "My-profile",
    icon: myprofile,
    icon2: myprofile,
    to: "/ad/myprofile",
  },
];

export const Md_nav = [
  {
    title: "Dashboard",
    icon: dashboards,
    icon2: DashboardIconWhite,
    to: "/md/dashboard",
  },
  {
    title: "Users",
    icon: user1,
    icon2: UserIconWhite,
    to: "/md/users",
  },
  {
    title: "Fund  Request",
    icon: creditrq1,
    icon2: CreditRequestIcon,
    to: "/md/cred-req",
  },
  {
    title: "Transactions",
    icon: transaction1,
    icon2: TransactionIconWhite,
    to: "/md/transactions",
  },

  // {
  //   title: "Bank List",
  //   icon: creditrq1,
  //   icon2: CreditRequestIcon,
  //   to: "/md/bank-list",
  // },
  {
    title: "Reports",
    icon: graph,
    icon2: ReportsIcon,
    to: "/md/reports",
    submenus: [
      {
        title: "Value In",
        icon: mysale,
        icon2: TransactionIconWhite,
        to: "/md/sale",
      },
      {
        title: "Value Out",
        icon: mypurchase,
        icon2: TransactionIconWhite,
        to: "/md/purchase",
      },
    ],
  },
  {
    title: "My Earning",
    icon: graph,
    icon2: ReportsIcon,
    to: "/md/my-earning",
  },

  {
    title: "Account Ledger",
    icon: ledgerIcon,
    icon2: ledgerIcon,
    to: "/md/account-ledger",
  },
  {
    title: "Login History",
    icon: loginHistory,
    icon2: TransactionIconWhite,
    to: "/md/loginHistory",
  },
  {
    title: "My-profile",
    icon: myprofile,
    icon2: myprofile,
    to: "/md/myprofile",
  },
  // {
  //   title: "Contact Us",
  //   icon: <SupportAgentIcon />,
  //   to: "/ad/cred-req",
  // },
];
// this is the nav for the old layout
export const customer_nav = [
  {
    title: "Home",
    icon: home,
    icon2: home,
    to: "/customer/dashboard",
  },
  // {
  //   title: "Recharge/Bill",
  //   icon: Recharge,
  //   icon2: RechargeIcon,
  //   to: "/customer/recharge",
  // },

  // {
  //   title: "BBPS",
  //   icon: bharatbig,
  //   icon2: BbpsIcon,
  //   to: "/customer/bbps",
  // },
  // {
  //   title: "CMS",
  //   icon: Cms2,
  //   icon2: cmsIconWhite,
  //   to: "/customer/cms",
  // },
  // {
  //   title: "Money Transfer",
  //   icon: transfer1,
  //   icon2: MoneyTransferIcon,
  //   to: "/customer/money-transfer",
  // },
  // {
  //   title: "Express Transfer",
  //   icon: ExpressIcon,
  //   icon2: ExpressIcon,
  //   to: "/customer/express-transfer",
  // },
  // {
  //   title: "Super Transfer",
  //   icon: SuperIcon,
  //   icon2: SuperIcon,
  //   to: "/customer/super-transfer",
  // },

  // {
  //   title: "Nepal Transfer",
  //   icon: NepalIcon,
  //   icon2: NepalIcon,
  //   to: "/customer/nepal-transfer",
  // },
  // {
  //   title: "UPI Transfer",
  //   icon: Upi,
  //   icon2: UpiIcon,
  //   to: "/customer/upi-transfer",
  // },
  // {
  //   title: "AEPS",
  //   icon: AEPS1,
  //   icon2: AepsIcon,
  //   to: "/customer/aeps",
  // },
  // {
  //   title: "Travel",
  //   icon: Travel,
  //   icon2: FlightIcon,
  //   to: "/customer/travel",
  //   // to: "/customer/travel-services",
  // },
  {
    title: "Fund Request",
    icon: creditmoney,
    icon2: CreditRequestIcon,
    to: "/customer/cred-req",
  },

  {
    title: "My Complaints",
    icon: complaint,
    icon2: ComplaintsIconWhite,
    to: "/customer/complaints",
  },
  {
    title: "Collections",
    icon: complaint,
    icon2: ComplaintsIconWhite,
    to: "/customer/collection",
  },

  {
    title: "My Purchase",
    icon: mypurchase,
    icon2: TransactionIconWhite,
    to: "/customer/purchase",
  },

  // {
  //   title:"Logout",
  //   icon: mypurchase,
  //   to:"/login",
  //   },

  // {
  //   title: "User Profile",
  //   icon: maleAvatar, // Import the avatar icon or use a default user icon
  //   icon2: femaleAvatar, // Adjust accordingly
  //   userProfile: true, // This indicates it contains user information
  //   submenus: [
  //     {
  //       title: "Manage Your Profile",

  //       to: "/customer/my-profile",
  //     },
  //   ],
  // },

  {
    title: "Send Money",
    icon: sendicon,
    icon2: sendicon,
    to: "/customer/sendmoney",
  },
  {
    title: "Receive Money",
    icon: Qr,
    icon2: Qr,
    to: "/customer/qrCode",
  },
  //    {
  //   title: "Receive Money2",
  //   icon: mypurchase,
  //   icon2: TransactionIconWhite,
  //   to: "/customer/payment",

  // },
  {
    title: "W2 to W1 Transfer",
    icon: walletIcon,
    icon2: walletIcon,
    to: "/customer/w2tow1",
  },
  {
    title: "Move To Bank",
    icon: bankTransfer,
    icon2: bankTransfer,
    to: "/customer/bankTransfer",
  },

  // {
  //   title: "Bank List",
  //   icon: creditrq1,
  //   icon2: CreditRequestIcon,
  //   to: "/customer/bank-list",
  // },
  {
    title: "Reports",
    icon: graph,
    icon2: ReportsIcon,
    to: "/customer/transactions",
  },
  {
    title: "My Earning",
    icon: graph,
    icon2: ReportsIcon,
    to: "/customer/my-earning",
  },
  {
    title: "Account Ledger",
    icon: ledgerIcon,
    icon2: ledgerIcon,
    to: "/customer/account-ledger",
  },
  {
    title: "My-profile",
    icon: myprofile,
    icon2: myprofile,
    to: "/customer/myprofile",
  },

  {
    title: "Login History",
    icon: loginHistory,
    icon2: TransactionIconWhite,
    to: "/customer/loginHistory",
  },
  // {
  //         title: "Khata Book",
  //         icon: Book,
  //         icon2: AccountIcon,
  //         to: "/customer/khata-book",
  //       },
  {
    title: "IRCTC",
    icon: train,
    icon2: trainIconWhite,
    to: "https://www.irctc.co.in/nget/train-search",
  },

  // {
  //   title: "Reports",
  //   icon: ReportsIcon,
  //   icon2: ReportsIcon,
  //   to: "#",
  //   submenus: [
  //     {
  //       title: "My Transactions",
  //       icon: TransactionIcon,
  //       icon2: TransactionIconWhite,
  //       to: "/customer/transactions",
  //     },
  //     {
  //       title: "Account Ledger",
  //       icon: AccountIcon,
  //       icon2: AccountIconWhite,
  //       to: "/customer/account-ledger",
  //     },
  //     {
  //       title: "My Complaints",
  //       icon: ComplaintsIcon,
  //       icon2: ComplaintsIconWhite,
  //       to: "/customer/complaints",
  //     },
  //     {
  //       title: "My Purchase",
  //       icon: TransactionIcon,
  //       icon2: TransactionIconWhite,
  //       to: "/customer/purchase",
  //     },
  //     {
  //       title: "Khata Book",
  //       icon: AccountIcon,
  //       icon2: AccountIcon,
  //       to: "/customer/khata-book",
  //     },
  //   ],
  // },
];

export const user_Role = [
  {
    title: "Service",
    icon: home,
    icon2: home,
    to: "/user/BBPSView",
  },
  {
    title: "My Billers",
    icon: invoicesvg,
    icon2: invoicesvg,
    to: "/user/billers",
  },
  {
    title: "Report",
    icon: graph,
    icon2: graph,
    to: "/user/transactions",
  },
];
export const Corp_Role = [
  {
    title: "Service",
    icon: graph,
    icon2: ReportsIcon,
    to: "/corp/BBPSView",
    submenus: [
      {
        title: "BBPS",
        icon: mypurchase,
        icon2: TransactionIconWhite,
        to: "/corp/BBPSView",
      },
    ],
  },
  // {
  //   title: "Service",
  //   icon: home,
  //   icon2: home,
  //   to: "/corp/BBPSView"
  // },
  {
    title: "My Billers",
    icon: invoicesvg,
    icon2: invoicesvg,
    to: "/corp/billers",
  },
  {
    title: "Report",
    icon: graph,
    icon2: graph,
    to: "/corp/transactions",
  },
  {
    title: "Fund Request",
    icon: graph,
    icon2: graph,
    to: "/corp/cred-req",
  },
  // {
  //   title: "Bank List",
  //   icon: creditrq1,
  //   icon2: graph,
  //   to: "/corp/cred-req",
  // },
  {
    title: "My Earning",
    icon: graph,
    icon2: graph,
    to: "/corp/my-earning",
  },
  {
    title: "Account Ledger",
    icon: graph,
    icon2: graph,
    to: "/corp/account-ledger",
  },
  {
    title: "Value In",
    icon: graph,
    icon2: graph,
    to: "/corp/purchase",
  },
  {
    title: "Value Out",
    icon: graph,
    icon2: graph,
    to: "/corp/sale",
  },
];
// ******************************************************************
// #############################################
// these are the navs for the new layout
// #############################################
// ******************************************************************
export const reports = [
  {
    title: "Dashboard",
    icon: dashboard,
    to: "/customer/dashboard",
  },
  {
    title: "My Transactions",
    icon: transaction1,
    to: "/customer/transactions",
  },
  {
    title: "Account Ledger",
    icon: account_ledgre,
    to: "/customer/account-ledger",
  },
  {
    title: "Fund  Request",
    icon: creditReq,
    to: "/customer/cred-req",
  },
  {
    title: "My Complaints",
    icon: myComplaints,
    to: "/customer/complaints",
  },
  {
    title: "My Purchase",
    icon: myPurchase,
    to: "/customer/purchase",
  },
  {
    title: "Khata Book",
    icon: khataBook,
    to: "/customer/khata-book",
  },
];

export const banking = [
  {
    title: "Money Transfer",
    icon: mtIcon,
    to: "/customer/money-transfer",
  },
  {
    title: "Settlements",
    icon: stIcon,
    to: "/customer/settlements",
  },
  {
    title: "Express Transfer",
    icon: etIcon,
    to: "/customer/express-transfer",
  },
  {
    title: "Super Transfer",
    icon: stIcon,
    to: "/customer/super-transfer",
  },
  {
    title: "AEPS",
    icon: aepsIcon,
    to: "/customer/aeps",
  },
  {
    title: "Nepal Transfer",
    icon: ntIcon,
    to: "/customer/nepal-transfer",
  },
  {
    title: "CMS",
    icon: CMSIcon,
    to: "/customer/cms",
  },
  {
    title: "UPI Transfer",
    icon: utIcon,
    to: "/customer/upi-transfer",
  },
];

export const bbpsServices = [
  {
    title: "Electricity",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "Gas Cylinder",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "Mobile Postpaid",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "Mobile Prepaid",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "FASTag",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "Piped Gas",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
    isModal: true,
  },
  {
    title: "BBPS",
    icon: <FormatBoldIcon />,
    to: "/customer/bbps",
  },
];
export const ourServices = [
  {
    title: "Mobile Recharge",
    icon: Prepaid,
    to: "",
    isModal: true,
  },
  {
    title: "DTH Recharge",
    icon: dthIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Electricity with commission",
    icon: elecIcon,
    to: "",
    isModal: true,
  },
  {
    title: "LIC Premium",
    icon: licIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Credit Card Bill",
    icon: cardIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Gas Bill",
    icon: gasIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Broadband Bill",
    icon: bbIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Water Bill",
    icon: waterIcon,
    to: "",
    isModal: true,
  },
  {
    title: "Landline Bill",
    icon: landIcon,
    to: "",
    isModal: true,
  },
  // {
  //   title: "Recharges",
  //   icon: Prepaid,
  //   to: "/customer/recharge",
  // },
];

export const travelServices = [
  {
    title: "Flight Booking",
    icon: flightBooking,
    to: "/customer/travel",
  },
  {
    title: "IRCTC Booking",
    icon: irctcTravelImage,
    to: "https://www.irctc.co.in/nget/train-search",
    target: "_blank",
  },
  {
    title: "Hotel Booking",
    icon: hotelBooking,
    to: "/customer/travel",
  },
  {
    title: "Bus Booking",
    icon: busBooking,
    to: "/customer/travel",
  },
];

export const getNavImg = (title) => {
  let image;
  switch (title) {
    case "Electricity":
      image = Electricity;
      break;
    case "FASTag":
      image = FASTag;
      break;
    case "BBPS":
      image = BBPS;
      break;
    case "Gas Cylinder":
      image = Cylinder;
      break;
    case "Mobile Postpaid":
      image = Postpaid;
      break;
    case "Mobile Prepaid":
      image = Prepaid;
      break;
    case "Piped Gas":
      image = Gas;
      break;

    default:
      image = BBPS;
  }
  return image;
};

// export const customer_nav_super = [
//   {
//     title: "Dashboard",
//     icon: <HomeOutlinedIcon />,
//     to: "/customer/dashboard",
//   },
//   {
//     title: "Recharge/Bill",
//     icon: <RechargeIconutlinedIcon />,
//     to: "/customer/RechargeIcon",
//   },
//   {
//     title: "BBPS",
//     icon: <FormatBoldIcon />,
//     to: "/customer/bbps",
//   },
//   {
//     title: "Money Transfer",
//     icon: <SwapHorizIcon />,
//     to: "/customer/money-transfer",
//   },
//   {
//     title: "Express Transfer",
//     icon: <SwipeRightOutlinedIcon />,
//     to: "/customer/express-transfer",
//   },
//   {
//     title: "Super Transfer",
//     icon: <BoltIcon />,
//     to: "/customer/super-transfer",
//   },
//   {
//     title: "UPI Transfer",
//     // icon: <SyncAltOutlinedIcon />,
//     icon: <QrCodeScannerIcon />,
//     to: "/customer/upi-transfer",
//   },
//   {
//     title: "AEPS",
//     icon: <TouchAppOutlinedIcon />,
//     to: "/customer/aeps",
//   },
//   {
//     title: "My Transactions",
//     icon: <ShuffleIcon />,
//     to: "/customer/transactions",
//   },
//   {
//     title: "Credit Request",
//     icon: <CurrencyRupeeOutlinedIcon />,
//     to: "/customer/cred-req",
//   },
//   {
//     title: "My Complaints",
//     icon: <SupportAgentIcon />,
//     to: "/customer/complaints",
//   },
//   {
//     title: "My Purchase",
//     icon: <FontAwesomeIcon icon={faLink} style={{ fontSize: "18px" }} />,
//     to: "/customer/purchase",
//   },
//   {
//     title: "Khata Book",
//     icon: <MenuBookOutlinedIcon />,
//     to: "/customer/khata-book",
//   },
// ];
export const account_nav = [
  {
    title: "Dashboard",
    icon: DashboardIcon,
    icon2: DashboardIconWhite,
    to: "/account/dashboard",
  },
];

//acc login
//user
//bank
//account
//txn
